import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";
import { queryKeys } from "@/lib/queryClient";
import type { Workspace } from "@/lib/types";

// Reads the shared workspaces cache. `usePersonalWorkspaceId` returns the id of
// the single system "Persönlich" workspace (or null); used to badge personal
// boards and to gate management UI without threading the flag through props.
export function usePersonalWorkspaceId(): string | null {
  const { data } = useQuery<Workspace[]>({
    queryKey: queryKeys.workspaces,
    queryFn: api.listWorkspaces,
    staleTime: 5 * 60_000,
  });
  return (data ?? []).find((w) => w.is_personal)?.id ?? null;
}
